module.exports = __webpack_public_path__ + "static/media/02-telefonica.650c47fb.png";